<template>
  <div>
    <div class="my-container">
      <h2>Search CancerSRT</h2>
      <el-form :model="form" label-width="250px" size="small" style="margin-top: 10px">
        <el-form-item label="Gene Symbol or Ensembl ID:" required>
          <el-input v-model="form.Gene" placeholder="e.g. A1BG" style="width: 200px;float: left"></el-input>
          <span style="float: left;margin-left: 20px;">Please input Gene Symbol or Ensembl ID: such as A1BG or ENSG00000121410.  (necessary)</span>
        </el-form-item>
        <el-form-item label="Technique:">
          <el-select v-model="form.Technique" placeholder="please select" style="width: 200px;float: left">
            <el-option label="all" value="all"></el-option>
            <el-option label="ST" value="ST"></el-option>
            <el-option label="Visium" value="Visium"></el-option>
            <el-option label="LCM-seq" value="LCM-seq"></el-option>
          </el-select>
          <span style="float: left;margin-left: 20px">Please select technique to browse.  (option)</span>
        </el-form-item>
        <el-form-item label="PMID:">
          <el-input v-model="form.PMID" placeholder="e.g. 34083791" style="width: 200px;float: left"/>
          <span style="float: left;margin-left: 20px">Please select PMID to browse.  (option)</span>
        </el-form-item>
        <el-form-item label="Type:">
          <el-select v-model="form.Type" placeholder="please select" style="width: 200px;float: left">
            <el-option label="all" value="all"></el-option>
            <el-option label="Breast cancer" value="Breast Cancer"></el-option>
            <el-option label="PDAC" value="PDAC"></el-option>
            <el-option label="cSCC" value="cSCC"></el-option>
            <el-option label="Melanoma" value="Melanoma"></el-option>
            <el-option label="Prostate Cancer" value="prostate cancer"></el-option>
            <el-option label="Liver Cancer" value="liver cancer"></el-option>
            <el-option label="Ovarian Cancer" value="OvarianCancer"></el-option>
            <el-option label="Glioblastoma" value="Glioblastoma"></el-option>
            <el-option label="Colorectal Cancer" value="Colorectal Cancer"></el-option>
            <el-option label="Cervical Cancer" value="Cervical Cancer"></el-option>
<!--            <el-option label="Intestine Cancer" value="Intestine Cancer"></el-option>-->
            <el-option label="Bladder Cancer" value="Bladder Cancer"></el-option>
            <el-option label="Brain Metastases" value="Brain metastases"></el-option>
            <el-option label="Lung Cancer" value="Lung cancer"></el-option>
            <el-option label="Head and neck Cancer" value="Head and neck Cancer"></el-option>
          </el-select>
          <span style="float: left;margin-left: 20px">Please select cancer type to browse.  (option)</span>
        </el-form-item>
        <el-button size="mini" type="info" round @click="onSubmit" id="search_button">Search</el-button>
      </el-form>

      <!--      <scan>&nbsp;&nbsp;&nbsp;&nbsp;Please select species to browse.</scan>-->
      <!--      <scan>&nbsp;&nbsp;&nbsp;&nbsp;Please input Gene or ENSEMBL ID: such as Kctd12 or ENSMUSG00000098557.</scan>-->
    </div>
    <div class="my-container">
      <h2>
        Search Results
      </h2>
      <div>
        <el-table
            :data="tableData.slice((currentPage-1)*pageSize,currentPage*pageSize)"
            stripe
            :row-style="{height: '10px'}"
            :cell-style="{padding: '0', color: 'black', margin: '0'}"
            :header-cell-style="{padding: '0', margin: '0', fontSize: '10px', color: 'black'}">
          <el-table-column prop="datasetname" label="DATASET" sortable show-overflow-tooltip>
          </el-table-column>
          <el-table-column prop="ensembl_ID" label="ENSEMBL_ID" width="170" sortable show-overflow-tooltip>
          </el-table-column>
          <el-table-column prop="gene" label="GENE" width="100" show-overflow-tooltip>
          </el-table-column>
          <el-table-column prop="type" label="TYPE" sortable show-overflow-tooltip>
          </el-table-column>
          <el-table-column prop="name" label="SAMPLE" width="130" sortable show-overflow-tooltip>
          </el-table-column>
          <el-table-column prop="technique" label="TECHNIQUE" sortable show-overflow-tooltip>
          </el-table-column>
          <el-table-column prop="pmid" label="PMID" width="100" sortable show-overflow-tooltip>
            <template slot-scope="scope">
<!--              <a target="_blank" class="buttonText" href="https://pubmed.ncbi.nlm.nih.gov/30154148/">link</a>-->
              <a target="_blank" class="buttonText" :href="gotoDetails(scope.row.pmid)">{{scope.row.pmid}}</a>
<!--              <a v-on:click="gotoDetails(scope.row.pmid)" class="my-a"></a>-->
            </template>
          </el-table-column>
<!--          <el-table-column prop="browse" label="BROWSE" width="100">-->
<!--            <template slot-scope="scope">-->
<!--                            <a target="_blank" class="buttonText" href="https://pubmed.ncbi.nlm.nih.gov/30154148/">link</a>-->
<!--              <a v-on:click="gotoDetails(scope.row.pmid)" class="my-a">link</a>-->
<!--            </template>-->
<!--          </el-table-column>-->
        </el-table>
      </div>
      <!-- 分页器 -->
      <el-pagination align='center' @size-change="handleSizeChange" @current-change="handleCurrentChange"
                     :current-page="currentPage"
                     :page-sizes="[1,5,10,20]"
                     :page-size="pageSize"
                     layout="total, sizes, prev, pager, next, jumper"
                     :total="tableData.length">
      </el-pagination>
    </div>

  </div>
</template>

<script>

export default {
  name: "Search",
  data() {
    return {
      form: {
        Type: '',
        Gene: '',
        Technique: 'all',
        PMID:''
      },
      tableData: [
      ],
      currentPage: 1, // 当前页码
      total: 20, // 总条数
      pageSize: 10 // 每页的数据条数
    };
  },
  created() {
    this.getRouterData()
  },
  methods: {
    getRouterData() {
      let _this = this
      if (_this.$route.query.Gene === undefined){
        _this.form.Gene = 'A1BG'
        _this.form.Type = 'Breast Cancer'
        console.log('/Search')
        _this.onSubmit()
      }else {
        _this.form = _this.$route.query
        // console.log(_this.$route.query)
        _this.onSubmit()
      }
    },
    //每页条数改变时触发 选择一页显示多少行
    handleSizeChange(val) {
      console.log(`每页 ${val} 条`);
      this.currentPage = 1;
      this.pageSize = val;
    },
    //当前页改变时触发 跳转其他页
    handleCurrentChange(val) {
      console.log(`当前页: ${val}`);
      this.currentPage = val;
    },
    gotoDetails(DETAILS) {
      return 'https://pubmed.ncbi.nlm.nih.gov/'+DETAILS+'/'
    },
    onSubmit(){
      let _this = this
      console.log("submit")
      if (_this.form.Gene === ''){
        _this.$message.warning("Please Input Necessary Information")
        return
      }
      console.log(_this.$global.serverIP+':'+_this.$global.serverHost)
      console.log(_this.form)
      _this.$axios.post(
          'http://'+ _this.$global.serverIP+':'+_this.$global.serverHost + '/search',
          _this.form)
          .then(function (response){
            // console.log('response:')
            // console.log(response)
            _this.tableData = response.data
            if (_this.tableData.length === 0){
              _this.$message.info("No data queried")
            }
          })
    }
  }
}
</script>

<style scoped>
.el-form-item {
  text-align: left;
}
.my-a{
  cursor:pointer;
  color: blue;
  text-decoration:underline;
}
#search_button{
  color: #FFFFFF;
  background-color: #173161;
  margin-bottom: 10px
}
</style>
